<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        
        <v-col id="base" md="12" style="height: 100%; position: relative; display: flex;
      flex-direction: column;" class="mt-0 pt-0" >
            <!-- Header -->
            <v-row justify="center" align="center" :style="{ 'background-color': $store.state.colors.primary }" class="pb-3">
                <v-img max-width="230px" height="80px" contain :src="$store.state.logoSRC"></v-img>
            </v-row>
            <v-row justify="center" align="start" style="background-color: white; border-bottom: 3px solid #E8E8E8; height: 120px" >
                <v-col class="mt-0 pt-1 RestoRegular">
                    <v-row style="font-size: 18px; color: #4D4D4D" class="pt-2 ">
                        <p class="pl-4" v-if="continueVar==true">Encontramos esta sucursal cerca de ti</p>
                        <p class="pl-4" v-else>Selecciona tu ubicación para encontrar la sucursal más cercana</p>
                        <vue-google-autocomplete
                            v-model="autocomplete"
                            class="mb-6"
                            ref="address"
                            id="map"
                            classname="form-control"
                            placeholder="Ingrese su dirección"
                            v-on:placechanged="getAddressData"
                            country="mx"
                            style="width: 90%; margin: 0 auto"
                        >
                        </vue-google-autocomplete>
                    </v-row>
                </v-col>
            </v-row> 
            <!-- New content -->
            <v-row v-if="val==false" style="height: 100%;" >         
                <Mapa v-if="validate==true" :newAutocomplete="newAutocomplete" :validateA="validateA" :lng="lng" :lat="lat" class="mapa"/>
            </v-row>
            <v-row v-if="newAutocomplete==false" style="height: 100%;" >         
                    <Mapa v-if="validateA==true" :newAutocomplete="newAutocomplete" :validateA="validateA" :lng="lng" :lat="lat" class="mapa"/>
            </v-row>
            <v-row v-else style="height: 100%;" >       
                <Mapa1  :newAutocomplete="newAutocomplete" :validateA="validateA" :lng="lng" :lat="lat" class="mapa"/>
            </v-row>
            <!-- Button Continue -->
            
        <v-row justify="center" class="pr-0 pl-0">
            <br><br><br>
            <v-btn @click="$router.push({ name: 'registerStep2'});" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 90%; height: 55px; margin: 15px; ">
                <span style="float: left; padding-left:0px;">Continuar</span>
                <v-spacer></v-spacer>
                <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
            </v-btn>
            <v-btn @click="$router.push({ name: 'registerStep1'});" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 90%; height: 55px; margin: 15px; ">
                <span style="float: left; padding-left:0px;">Regresar</span>
                <v-spacer></v-spacer>
            </v-btn>
        </v-row>
            

        </v-col>
    </v-row>
</template>

<script>
import Mapa from "./maps/Map.vue"; 
import Mapa1 from "./maps/Map.vue";
import VueGoogleAutocomplete from 'vue-google-autocomplete'
export default {
    components:{
      Mapa,
      Mapa1,
      VueGoogleAutocomplete
    },
    data()
    {
        return{
            val:false,
            lng: -102.5527878,
            lat:23.6345005,
            validate:false,
            continueVar:false,
            address:'',
            validateA:false,
            autocomplete:'',
            numberValidation:0,
            newAutocomplete:false,
        }
    },
    mounted()
    {
        this.$refs.address.focus();
    },
    watch:{
        autocomplete:function()
        {
            // console.log('Cambio');
            this.validateA=false;
        }
    },
    computed:{
      checkAddress: function (){
        if (this.address) { 
          this.locator();
          return false 
        } return true;
      },
    },
    async created() {
            this.$store.state.logo = false;
                var callback
                var coords={
                    lat:null,
                    lng:null,
                };
                const getCoor = coords => {
                    return new Promise((resolve, reject) => {
                        if(navigator.geolocation) 
                        {
                            navigator.geolocation.getCurrentPosition(function(position) 
                            { 
                                // console.log('hello');
                                // console.log(position.coords.latitude);
                                // console.log(position.coords.longitude);
                                coords.lng=position.coords.longitude;
                                resolve(position.coords);
                                navigator.geolocation.getCurrentPosition(callback, function(){
                                    
                                },{maximumAge:0, timeout:10000}); 
                            },function(){
                                
                            }, {maximumAge:0, timeout:10000});                          
                        }
                        else{
                            console.log('Ocurrió un error al obtener localización');
                            reject(status);
                        }
                    });
                };
                let location = await getCoor(coords);
                if(location.longitude)
                {
                    this.lng= location.longitude;
                    this.lat= location.latitude; 
                    this.validate=true;
                }
                else{
                    console.log('Ocurrió un error');
                    this.validate=true;
                }
                // console.log('Hola: '+this.lng);                    
        },
    methods:{
        getAddressData: function (addressData, placeResultData, id) {
            this.address = addressData;
            // console.log(placeResultData);
            // console.log(placeResultData.geometry.location.lat());
            // console.log(placeResultData.geometry.location.lng())
            console.log(id);
            this.lng=placeResultData.geometry.location.lng();
            this.lat=placeResultData.geometry.location.lat();
              localStorage.setItem("latitude",this.lat);
              localStorage.setItem("longitude",this.lng);
              if(placeResultData.address_components.length==5)
              {
                localStorage.setItem("calle",placeResultData.address_components[0].long_name);
                localStorage.setItem("colonia",placeResultData.address_components[1].long_name);
                localStorage.setItem("ciudad",placeResultData.address_components[3].long_name);
                localStorage.setItem("cp",' ');
                localStorage.setItem("num_exterior",' ');
                localStorage.setItem("estado",placeResultData.address_components[2].long_name);
                localStorage.setItem("validation",true);
              }
              else if(placeResultData.address_components.length==6)
              {
                localStorage.setItem("calle",placeResultData.address_components[0].long_name);
                localStorage.setItem("colonia",placeResultData.address_components[1].long_name);
                localStorage.setItem("ciudad",placeResultData.address_components[3].long_name);
                localStorage.setItem("cp",placeResultData.address_components[5].long_name);
                localStorage.setItem("num_exterior",'');
                localStorage.setItem("estado",placeResultData.address_components[2].long_name);
                localStorage.setItem("validation",true);
              }
              else if(placeResultData.address_components.length==7)
              {
                    localStorage.setItem("calle",placeResultData.address_components[1].long_name);
                    localStorage.setItem("num_exterior",placeResultData.address_components[0].long_name);
                    localStorage.setItem("colonia",placeResultData.address_components[2].long_name);
                    localStorage.setItem("ciudad",placeResultData.address_components[4].long_name);
                    localStorage.setItem("cp",placeResultData.address_components[6].long_name);
                    localStorage.setItem("estado",placeResultData.address_components[3].long_name);
                    localStorage.setItem("validation",true);
              }
              else if(placeResultData.address_components.length==3)
              {
                    localStorage.setItem("calle",placeResultData.address_components[0].long_name);
                    localStorage.setItem("num_exterior",' ');
                    localStorage.setItem("colonia",' ');
                    localStorage.setItem("ciudad",' ');
                    localStorage.setItem("cp",' ');
                    localStorage.setItem("estado",placeResultData.address_components[1].long_name);
                    localStorage.setItem("validation",true);                  
              }
              else if(placeResultData.address_components.length==4)
              {
                    localStorage.setItem("calle",placeResultData.address_components[0].long_name);
                    localStorage.setItem("num_exterior",' ');
                    localStorage.setItem("colonia",' ');
                    localStorage.setItem("ciudad",placeResultData.address_components[1].long_name);
                    localStorage.setItem("cp",' ');
                    localStorage.setItem("estado",placeResultData.address_components[2].long_name);
                    localStorage.setItem("validation",true);
              }
              else{
                    localStorage.setItem("calle",' ');
                    localStorage.setItem("num_exterior",' ');
                    localStorage.setItem("colonia",' ');
                    localStorage.setItem("ciudad",' ');
                    localStorage.setItem("cp",' ');
                    localStorage.setItem("estado",' ');
                    localStorage.setItem("validation",true);                 
              }

            if(this.numberValidation==0)
            {
                this.numberValidation=1;
                this.validateA=true;
                this.newAutocomplete=false;
                this.val=true;
            }
            else{
                localStorage.setItem("latA",this.lat);
                localStorage.setItem("lonA",this.lng)
                this.numberValidation=0;
                this.newAutocomplete=true;
                this.validateA=false;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.mapa {
    height: 300px;
  }
</style>